// Thin client helper: posts to the site's own server routes, which send the
// email server-side. Sends are fire-and-forget — a failed email must never
// block a form's success state.
type EmailAction = 'lead-notification' | 'contact-confirmation' | 'family-guide'

export function postAppEmail(action: EmailAction, body: Record<string, unknown>) {
  return fetch(`/api/public/email/${action}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).catch(() => undefined)
}
